import { useGSAP } from "@gsap/react";
import React from "react";
import gsap from "gsap";
import { rightImg, watchImg } from "../utils";
import VideoCarousel from "./videoCarousel";

const Highlights = () => {
  useGSAP(() => {
    gsap.from("#highlights", {
      opacity: 0,
      duration: 2.5,
    });
    gsap.from("#link", {
      opacity:0,
      stagger:1,
      duration:1.5,
      y: -20,
    });
  }, []);
  return (
    <section
      id="highlights"
      className="w-screen overflow-hidden h-full bg-zinc-950 sm:py-14 py-20 sm:px-10 px-5"
    >
      <div className="screen-max-width">
        <div className="mb-12 w-full md:flex items-center justify-between">
          <h1
            id="title"
            className="text-gray-400 lg:text-6xl md:text-5xl text-3xl lg:mb-0 mb-5 font-medium "
          >
            Get the Highlights.
          </h1>

          <div id="wtf" className="flex flex-wrap items-end gap-5">
            <div id="link" className="text-blue-500 hover:underline cursor-pointer flex items-center text-xl">
              Watch The Film <img className="ml-2" src={watchImg} alt="" />
            </div>
             <div id="link" className="text-blue-500 hover:underline cursor-pointer flex items-center text-xl">
              Watch The Event <img className="ml-2" src={watchImg} alt="" />
            </div>
          </div>
        </div>
        <VideoCarousel/>
      </div>
    </section>
  );
};

export default Highlights;
